export { default } from "./DatoCmsBlockQuoteEmoji"
